:host {
  margin-right: var(--z-icon-right-margin, 0);
  margin-left: var(--z-icon-left-margin, 0);
  line-height: 0;
  vertical-align: middle;
}

:host svg:not([width]) {
  width: var(--z-icon-width, 18px);
}

:host svg:not([height]) {
  height: var(--z-icon-height, 18px);
}
